/** Hosts where the developer shell may be rendered for an entitled user. */
export function isDeveloperHost(hostname: string | null | undefined): boolean {
  const host = (hostname ?? "").trim().toLowerCase().split(":")[0];
  return host === "vbrain.win" || host === "vdev.vbrain.io" || host === "vdev.gam.co.il";
}
